import React from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
} from "../../../../constants/SalesCustomerList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const SubsidyReconciliation = () => {
  const navigate = useNavigate();

  const handleOnAddCustomerButton = () => {
    navigate(ROUTES_NAVIGATION.ADDSALESCUSTOMER);
  };

  const handleSubsidyDetails = () => {
    navigate(ROUTES_NAVIGATION.VIEWSUBSIDY)
  }

  return (
    <ListPage
    isButtonRequired={false}
      headerTopText="Sales / Subsidy Reconciliation"
      headerTitle="Subsidy Reconciliation"
      // addButtonTitle="Add Customer"
      // uploadButtonTitle="Upload Customer"
      listTitle="All Customers"
      topDetailsList={topDataList}
      tableData={TABLE_DATA}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleOnAddButton={handleOnAddCustomerButton}
      handleOnUploadButton={() => {}}
      handleViewButton={handleSubsidyDetails}
    />
  );
};
export default SubsidyReconciliation;
